import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const ConjurationSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 60 60">
      <path
        fill={fillColor}
        d="M49.8 6.4q-.3-.6-1.3-.7c-.2 0-.6.7-.6 1.1v4.4q-.1 5.4-3.1 9.8-1.2 2-2.6 3.6a5 5 0 0 1-1.7 1.2 23 23 0 0 1-7.5 1.8q-6.6.8-12.9-1.5-1-.5-2-1.5l-2.5-3.8q-2.2-3-2.6-6.9l-.5-6.5c0-.6 0-1.5-.8-1.5q-.9.2-1.5 1Q8.6 10 9 13q.2 6 3.7 10.7 1 1.1 1.6 2.3 3.2 6.3 6.3 12.8.9 1.7-1.1 1.7-2.7 0-5-1.4c-.5-.5-1.3-1.3-2-.4s0 1.6.4 2.3q.6.8 1.3 1.3 3 2.4 7 1.9c2-.3 2.2-.3 3.2 1.6l2.8 5.6q.6 1.1 1.3 2c1.1 1.3 2.6 1.3 3.6 0q.7-1 1.2-2.1 3-5.6 5.7-11.3 1.1-2.4 3.7-2.3 2.4 0 4.4 1.2l1.4.9q.7.2 1.3 0c.2-.2.4-.9.2-1.2q-1-3.1-4.2-4l-1.9-.4q-1.5-.4-1-1.8 2-4.1 4.4-8c2.4-3.5 4-7.3 4-12.3q0-.9-.3-2.7a12 12 0 0 0-1-3M34.2 41.2l-3.3 6q-.1.3-.7.4-.5 0-.8-.6l-1.7-3.1q-.5-1.2.7-1.8l4.8-2c.7-.2 1.3.4 1 1m4.8-9.4c-.5 1.7-1.2 3-3 3.7l-8.3 3c-2 .8-2.5.6-3.5-1.2l-2.7-5.4q-.6-1.5 1-1.2 2.4.2 4.6.6c3.3.7 6.6.2 9.8-.4l1-.2q1.4 0 1 1.1"
      />
    </BaseSvg>
  );
};

export default ConjurationSvg;
